/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const TimestampLessThan: core.serialization.ObjectSchema<
    serializers.TimestampLessThan.Raw,
    Truvity.TimestampLessThan
> = core.serialization.object({
    value: core.serialization.date(),
});

export declare namespace TimestampLessThan {
    export interface Raw {
        value: string;
    }
}
